import React from 'react'
import { connect } from 'react-redux'
import {
  showPopupDialog,
  showPopupErrorSnackbar,
  showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import i18n from 'support/i18n'
import Navigation from 'support/navigation'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
import SucessSubmitModal from './dialogs/SucessSubmitContainer'
import View from './View'
import { postIdeaTemplateCreate } from 'services/innovate/templates'




const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,
  createIdeaTemplateLoading: state.data.templates.createIdeaTemplateLoading,
  updateIdeaTemplateLoading: state.data.templates.updateIdeaTemplateLoading,
  createIdeaTemplate:state.data.templates.createIdeaTemplate,
  updateIdeaTemplate:state.data.templates.updateIdeaTemplate
})

const mapDispatchToProps = dispatch => {
  return {
    postIdeaTemplateCreateFn:(email,adminCreateTemplateData)=>{
      console.log("create idea Value", adminCreateTemplateData)
      
      const onSuccess = data => {
        const message='Your Template is Successfully Created'
        // showPopupSuccessSnackbar(message, dispatch)
        showPopupDialog(<SucessSubmitModal description={message} />, dispatch)
      }
      const onFailure = ({ data }) => {
        // console.log("🚀 ~ onFailure ~ data:", data)
        const errorMessage = data?.error?.msg?.en || 'An unexpected error occurred';
        const messageTag =
          data && data.error && data.error.error
            ? `BACKEND_ERRORS.${data.error.error}`
            : 'BACKEND_ERRORS.UNEXPECTED'
            showPopupDialog(<ErrorSubmitModal description={errorMessage} />, dispatch)

            console.log('messageTag messageTag err',messageTag)
      }
      dispatch(postIdeaTemplateCreate(email,adminCreateTemplateData,onSuccess,onFailure))

    },

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)